import { mountWithdrawalControls } from './withdrawal-controls'
const ONBOARD_KEY = 'klfb_onboard_v1'

const PTR_SVG = `<svg viewBox="0 0 18 22" fill="none" aria-hidden="true"><path d="M2 1.5V17.2l4.1-3.5 2.4 5.6 2.3-1-2.4-5.5H15L2 1.5Z" fill="#fff" stroke="#1c1917" stroke-width="1.2" stroke-linejoin="round"/></svg>`

const CHROME_CSS = `
:host { all: initial; }
* { box-sizing: border-box; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, sans-serif; }
.layer { position: fixed; inset: 0; pointer-events: none; z-index: 2147483645; }
.layer > * { pointer-events: auto; }
.fab-stack {
  position: fixed; right: 14px; bottom: calc(18px + env(safe-area-inset-bottom, 0px));
  display: flex; flex-direction: column; align-items: flex-end; gap: 8px; z-index: 2;
}
.fab-menu {
  display: none; flex-direction: column; gap: 6px; align-items: flex-end;
}
.fab-menu.open { display: flex; }
.fab-chip {
  border: 0; border-radius: 999px; padding: 9px 12px;
  font: 600 12px/1 ui-sans-serif, system-ui, sans-serif; cursor: pointer;
  background: #1c1917; color: #f5f0ea;
  box-shadow: 0 6px 18px rgba(0,0,0,.25);
  display: flex; align-items: center; gap: 6px;
}
.fab-chip.done { background: #f5f3ff; color: #5b21b6; }
.fab-chip .count { display: none !important; /* Count nur im Sheet-Hint */ }
.fab-main {
  width: 56px; height: 56px; border-radius: 999px; border: 0;
  background: #6D28D9; color: #fff; cursor: pointer;
  box-shadow: 0 10px 28px rgba(109,40,217,.45);
  font: 700 12px/1.1 ui-sans-serif, system-ui, sans-serif;
  display: grid; place-items: center; position: relative;
}
.fab-main.marking {
  background: #11100f;
  box-shadow: 0 0 0 3px #6D28D9, 0 10px 28px rgba(0,0,0,.35);
  animation: pulse 1.4s ease-in-out infinite;
}
.fab-main .badge-n {
  display: none !important; /* KA-747: kein Dauer-Count auf FAB — Anzahl nur im Sheet */
}
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.04); }
}
.toast {
  position: fixed; left: 50%; top: 16px; transform: translateX(-50%);
  background: #1c1917; color: #f5f0ea; border-radius: 12px;
  padding: 10px 14px; font-size: 12px; line-height: 1.35;
  box-shadow: 0 8px 24px rgba(0,0,0,.28); z-index: 3;
  display: none; max-width: min(340px, calc(100vw - 32px)); text-align: center;
}
.toast.show { display: block; }
.toast strong { display: block; font-size: 13px; margin-bottom: 2px; }
.toast span { opacity: .8; }
.onboard {
  position: fixed; left: 12px; right: 12px; bottom: calc(88px + env(safe-area-inset-bottom, 0px));
  background: #1c1917; color: #f5f0ea; border-radius: 16px;
  padding: 12px 12px 10px; z-index: 4;
  box-shadow: 0 16px 40px rgba(0,0,0,.35);
  display: none; max-width: 360px; margin-inline: auto;
}
@media (min-width: 768px) {
  .onboard { left: auto; right: 14px; margin-inline: 0; width: 320px; }
}
.onboard.show { display: block; }
.onboard .step-dots { display: flex; gap: 5px; margin-bottom: 8px; padding: 0 2px; }
.onboard .step-dots i {
  width: 6px; height: 6px; border-radius: 50%; background: #44403c; display: block;
}
.onboard .step-dots i.active { background: #C4B5FD; }
.viz {
  position: relative; height: 118px; border-radius: 12px;
  background: linear-gradient(180deg, #1c1917 0%, #0c0a09 100%);
  border: 1px solid #292524; margin-bottom: 8px; overflow: hidden;
}
.viz-scene { display: none; position: absolute; inset: 0; }
.viz-scene.active { display: block; }
.onboard strong { display: block; font-size: 13px; margin: 0 2px 2px; }
.onboard p { font-size: 11px; opacity: .72; line-height: 1.35; margin: 0 2px 10px; }
.onboard-row { display: flex; gap: 8px; justify-content: space-between; align-items: center; }
.onboard-row button {
  border: 0; border-radius: 999px; padding: 7px 11px;
  font: 600 11px/1 ui-sans-serif, system-ui, sans-serif; cursor: pointer;
}
.onboard-row .skip { background: transparent; color: #a8a29e; }
.onboard-row .next { background: #6D28D9; color: #fff; margin-left: auto; }
.viz-ptr {
  position: absolute; width: 18px; height: 22px; z-index: 6;
  pointer-events: none; filter: drop-shadow(0 1px 2px rgba(0,0,0,.45));
  animation: ptrClick 1.8s ease-in-out infinite;
}
.viz-ptr svg { display: block; width: 100%; height: 100%; }
@keyframes ptrClick {
  0%, 100% { transform: translate(0, 0); }
  35% { transform: translate(1px, 2px); }
  48% { transform: translate(0, 0); }
}
.viz-fab {
  position: absolute; right: 16px; bottom: 14px; width: 32px; height: 32px;
  border-radius: 999px; background: #6D28D9; color: #fff;
  font: 700 8px/32px ui-sans-serif, system-ui, sans-serif; text-align: center;
  box-shadow: 0 6px 16px rgba(109,40,217,.45); z-index: 2;
}
.viz-scene[data-viz="0"] .viz-fab { animation: fabPulse 1.8s ease-in-out infinite; }
@keyframes fabPulse {
  0%, 100% { transform: scale(1); }
  40% { transform: scale(1.08); box-shadow: 0 0 0 6px rgba(109,40,217,.25); }
}
.viz-scene[data-viz="0"] .viz-ptr { right: 12px; bottom: 4px; }
.viz-page {
  position: absolute; inset: 10px;
  background: #f5f0ea; border-radius: 8px; padding: 8px; color: #1c1917;
}
.viz-line { height: 6px; border-radius: 4px; background: #d6d3d1; margin-bottom: 6px; }
.viz-line.w60 { width: 60%; } .viz-line.w80 { width: 80%; } .viz-line.w40 { width: 40%; }
.viz-block {
  height: 28px; border-radius: 6px; background: #e7e5e4; margin-top: 8px;
}
.viz-scene[data-viz="1"] .viz-block {
  outline: 2px solid #6D28D9;
  box-shadow: 0 0 0 3px rgba(109,40,217,.25);
  animation: markIn 1.6s ease-in-out infinite;
}
@keyframes markIn {
  0%, 30% { outline-color: transparent; box-shadow: none; }
  45%, 100% { outline-color: #6D28D9; box-shadow: 0 0 0 3px rgba(109,40,217,.25); }
}
.viz-scene[data-viz="1"] .viz-fab { opacity: .55; }
.viz-scene[data-viz="1"] .viz-ptr { left: 52%; top: 62%; right: auto; bottom: auto; animation-delay: .35s; }
.viz-composer {
  position: absolute; left: 12px; right: 12px; bottom: 14px; height: 34px;
  background: #fff; border-radius: 999px; display: flex; align-items: center;
  padding: 0 6px 0 12px; gap: 6px; color: #78716c; font-size: 10px;
}
.viz-composer .grow { flex: 1; position: relative; min-height: 12px; }
.viz-action { position: relative; width: 26px; height: 26px; flex-shrink: 0; }
.viz-mic, .viz-send {
  width: 26px; height: 26px; border-radius: 999px;
  display: grid; place-items: center; font-size: 12px; position: absolute; inset: 0;
}
.viz-mic { color: #6D28D9; background: rgba(109,40,217,.12); }
.viz-send { background: #6D28D9; color: #fff; opacity: 0; transform: scale(.7); }
.viz-scene[data-viz="2"] .viz-mic { animation: micToSend 2.4s ease-in-out infinite; }
.viz-scene[data-viz="2"] .viz-send { animation: sendIn 2.4s ease-in-out infinite; }
@keyframes micToSend {
  0%, 38% { opacity: 1; transform: scale(1); }
  52%, 100% { opacity: 0; transform: scale(.7); }
}
@keyframes sendIn {
  0%, 38% { opacity: 0; transform: scale(.7); }
  52%, 100% { opacity: 1; transform: scale(1); }
}
.viz-scene[data-viz="2"] .ph { animation: phOut 2.4s ease-in-out infinite; }
.viz-scene[data-viz="2"] .typed {
  position: absolute; left: 0; top: 50%; transform: translateY(-50%);
  color: #1c1917; font-weight: 600; font-size: 10px; white-space: nowrap;
  animation: typedIn 2.4s ease-in-out infinite;
}
@keyframes phOut { 0%, 28% { opacity: 1; } 42%, 100% { opacity: 0; } }
@keyframes typedIn {
  0%, 28% { opacity: 0; max-width: 0; overflow: hidden; }
  48%, 100% { opacity: 1; max-width: 160px; overflow: hidden; }
}
.viz-menu-chip {
  position: absolute; right: 14px; bottom: 56px;
  background: #f5f3ff; color: #5b21b6; border-radius: 999px;
  padding: 6px 10px; font-size: 9px; font-weight: 700;
  opacity: 0; transform: translateY(8px);
  animation: menuPop 2s ease-in-out infinite;
}
.viz-menu-chip:first-of-type { bottom: 86px; animation-delay: .15s; }
@keyframes menuPop {
  0%, 25% { opacity: 0; transform: translateY(8px); }
  40%, 100% { opacity: 1; transform: translateY(0); }
}
.viz-scene[data-viz="3"] .viz-fab { animation: holdPulse 2s ease-in-out infinite; }
@keyframes holdPulse {
  0%, 20% { transform: scale(1); }
  35%, 55% { transform: scale(1.06); box-shadow: 0 0 0 5px rgba(109,40,217,.3); }
  70%, 100% { transform: scale(1); }
}
.viz-scene[data-viz="3"] .viz-ptr {
  right: 12px; bottom: 4px; animation: ptrHold 2s ease-in-out infinite;
}
@keyframes ptrHold {
  0%, 20% { transform: translate(0, 0); }
  35%, 55% { transform: translate(1px, 2px); }
  70%, 100% { transform: translate(0, 0); }
}
.confirm {
  position: fixed; left: 12px; right: 12px; bottom: calc(88px + env(safe-area-inset-bottom, 0px));
  background: #faf8f5; color: #1c1917; border-radius: 16px;
  padding: 18px 16px; z-index: 5; display: none; text-align: center;
  box-shadow: 0 16px 40px rgba(0,0,0,.28); max-width: 360px; margin-inline: auto;
}
@media (min-width: 768px) {
  .confirm { left: auto; right: 14px; margin-inline: 0; width: 320px; }
}
.confirm.show { display: block; }
.confirm .emoji {
  width: 40px; height: 40px; border-radius: 999px; background: #f5f3ff; color: #6D28D9;
  display: grid; place-items: center; margin: 0 auto 10px; font-weight: 700;
}
.confirm h4 { margin: 0 0 6px; font-size: 16px; }
.confirm p { margin: 0 0 14px; font-size: 13px; color: #57534e; line-height: 1.4; }
.confirm-row { display: flex; gap: 8px; justify-content: center; flex-wrap: wrap; }
.confirm-row button {
  border: 0; border-radius: 999px; padding: 10px 14px;
  font: 600 13px/1 ui-sans-serif, system-ui, sans-serif; cursor: pointer;
}
.confirm-row .cancel { background: #e7e5e4; color: #1c1917; }
.confirm-row .primary { background: #6D28D9; color: #fff; }
.ended {
  position: fixed; left: 12px; right: 12px; top: 50%; transform: translateY(-50%);
  background: #1c1917; color: #f5f0ea; border-radius: 16px;
  padding: 20px 16px; z-index: 6; display: none; text-align: center;
  box-shadow: 0 16px 40px rgba(0,0,0,.35); max-width: 360px; margin-inline: auto;
}
.ended.show { display: block; }
.ended strong { display: block; font-size: 15px; margin-bottom: 6px; }
.ended span { font-size: 13px; opacity: .8; line-height: 1.4; }
.sheet-head {
  flex-shrink: 0;
  display: flex; align-items: center; gap: 6px;
  padding: 8px 10px 8px 14px; border-bottom: 1px solid #EDEAE3;
}
.sheet-drag {
  flex-shrink: 0; display: flex; justify-content: center; align-items: center;
  padding: 8px 0 2px; width: 100%; border: 0; background: transparent;
  cursor: ns-resize; touch-action: none; color: #a8a29e;
}
.sheet-drag-bar {
  width: 36px; height: 4px; border-radius: 999px; background: #d6d3d1;
}
.sheet-head h3 { margin: 0; font-size: 15px; flex: 1; min-width: 0; font-weight: 650; }
.sheet-filter {
  display: inline-flex; align-items: center; gap: 4px;
  min-height: 28px; padding: 0 8px;
  border: 1px solid #e7e5e4; border-radius: 999px;
  background: #fff; color: #44403c;
  font: 650 11px/1 ui-sans-serif, system-ui, sans-serif; cursor: pointer;
}
.sheet-filter[aria-expanded="true"] {
  background: #ede9fe; border-color: #c4b5fd; color: #5b21b6;
}
.sheet-filter .dot {
  width: 6px; height: 6px; border-radius: 50%; background: #6D28D9;
}
.sheet-close {
  width: 28px; height: 28px; border: 0; border-radius: 999px; cursor: pointer;
  background: transparent; color: #57534e; font-size: 18px; display: grid; place-items: center;
}
.filter-panel {
  display: none; flex-shrink: 0;
  padding: 8px 14px 10px; border-bottom: 1px solid #EDEAE3; background: #faf8f5;
}
.filter-panel.show { display: block; }
.filters { display: flex; flex-wrap: wrap; gap: 6px; }
.filters button {
  border: 1px solid #e7e5e4; background: #fff; color: #57534e;
  padding: 5px 10px; border-radius: 999px;
  font: 600 11px/1 ui-sans-serif, system-ui, sans-serif; cursor: pointer;
}
.filters button.on { background: #6D28D9; border-color: #6D28D9; color: #fff; }
.hint {
  flex-shrink: 0; font-size: 11px; color: #a8a29e;
  margin: 0; padding: 8px 16px 6px;
}
.list-sheet {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 5;
  --sheet-h: 58%;
  height: var(--sheet-h); max-height: 90%; min-height: 36%;
  background: #faf8f5; color: #1c1917; border-radius: 16px 16px 0 0;
  padding: 0;
  display: none; flex-direction: column;
  box-shadow: 0 -8px 32px rgba(0,0,0,.18);
  overscroll-behavior: contain; overflow: hidden;
}
@media (min-width: 768px) {
  .list-sheet {
    left: auto; right: 20px; bottom: 84px;
    width: min(400px, calc(100vw - 40px));
    border-radius: 16px;
  }
}
.list-sheet.show { display: flex; }
.list-backdrop {
  position: fixed; inset: 0; background: rgba(17,16,15,.35); z-index: 4; display: none;
}
.list-backdrop.show { display: block; }
.feed-status {
  font-size: 10px; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase;
  padding: 2px 7px; border-radius: 999px;
}
.feed-status.open { background: #ede9fe; color: #5b21b6; }
.feed-status.done { background: rgba(34,197,94,0.18); color: #15803d; }
.feed-status.discarded { background: #f5f5f4; color: #44403c; }
.feed-reason {
  margin-top: 4px; padding-top: 8px; border-top: 1px dashed #e7e5e4;
  font-size: 12px; color: #44403c; line-height: 1.4;
}
.feed-reason strong {
  display: block; font-size: 10px; text-transform: uppercase;
  letter-spacing: 0.04em; color: #78716c; margin-bottom: 2px;
}
.load-more {
  width: 100%; min-height: 36px; margin: 4px 0 8px;
  border: 1px dashed #d6d3d1; border-radius: 12px;
  background: #faf8f5; color: #44403c;
  font: 650 12px/1 ui-sans-serif, system-ui, sans-serif; cursor: pointer;
}
.load-more[hidden] { display: none; }
.list-scroll {
  flex: 1 1 auto; min-height: 0; overflow-y: auto; overflow-x: hidden;
  -webkit-overflow-scrolling: touch; touch-action: pan-y; overscroll-behavior: contain;
  padding: 4px 12px calc(14px + env(safe-area-inset-bottom, 0px));
  scrollbar-width: thin; scrollbar-color: #d6d3d1 #faf8f5;
}
.list-scroll::-webkit-scrollbar { width: 8px; }
.list-scroll::-webkit-scrollbar-track { background: #faf8f5; }
.list-scroll::-webkit-scrollbar-thumb {
  background: #d6d3d1; border-radius: 999px; border: 2px solid #faf8f5;
}
.list-empty { font-size: 13px; color: #78716c; padding: 8px 0 16px; }
/* Sand Feed-Molecule (AnnotationRow-Aufbau, hell) — KA-747 */
.feed-item {
  display: flex; flex-direction: column; gap: 8px;
  width: 100%; text-align: left;
  border: 1px solid #e7e5e4; background: #fff; border-radius: 12px;
  padding: 14px; margin-bottom: 6px; cursor: pointer; font: inherit; color: inherit;
}
.feed-item:active { background: #EDE9FE; }
.feed-head { display: flex; align-items: center; gap: 10px; }
.feed-avatar {
  width: 28px; height: 28px; border-radius: 50%;
  background: #EDE9FE; color: #6D28D9;
  font: 700 11px/28px ui-sans-serif, system-ui, sans-serif;
  text-align: center; flex-shrink: 0;
}
.feed-who { flex: 1; min-width: 0; }
.feed-who .name {
  font-size: 13px; font-weight: 700; color: #6D28D9; line-height: 1.2;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.feed-who .sub {
  display: flex; align-items: center; gap: 5px; flex-wrap: wrap;
  margin-top: 2px; font-size: 10px; color: #78716c;
}
.feed-idx {
  flex-shrink: 0; min-width: 22px; height: 22px; padding: 0 6px;
  border-radius: 999px; background: #EDE9FE; color: #6D28D9;
  font: 700 10px/22px ui-sans-serif, system-ui, sans-serif; text-align: center;
}
.feed-quote {
  background: #F8F6F1; border-left: 3px solid #6D28D9;
  border-radius: 5px; padding: 5px 10px;
}
.feed-quote .q-meta { font-size: 10px; color: #78716c; margin-bottom: 3px; }
.feed-quote .q-text { font-size: 12px; color: #1c1917; margin: 0; line-height: 1.45; }
.feed-body { font-size: 13px; color: #1c1917; margin: 0; line-height: 1.5; }
.list-item {
  border: 1px solid #e7e5e4; background: #fff; border-radius: 12px;
  padding: 10px 12px; margin-bottom: 8px;
}
.list-item .k { font-size: 11px; font-weight: 700; color: #6D28D9; }
.list-item .t { font-size: 13px; margin: 4px 0; color: #1c1917; }
.list-item .s { font-size: 11px; color: #78716c; }
.hidden { display: none !important; }
@media (prefers-reduced-motion: reduce) {
  .fab-main.marking, .viz-ptr, .viz-fab, .viz-block, .viz-mic, .viz-send, .viz-menu-chip,
  .viz-scene[data-viz="2"] .ph, .viz-scene[data-viz="2"] .typed { animation: none !important; }
}
`

const ONBOARD_STEPS = [
  { title: 'Button tippen', body: 'Startet den Markier-Modus.' },
  { title: 'Stelle antippen', body: 'Lila Rahmen = ausgewählt.' },
  { title: 'Sprechen oder tippen', body: 'Mikro → beim Tippen wird’s Senden.' },
  { title: 'Fertig?', body: 'Button halten → Meine Feedbacks oder abschließen.' },
]

export type ReviewerStatus = 'open' | 'done' | 'discarded'

export type SentFeedback = {
  todoId?: string
  canWithdraw?: boolean
  ownFeedback?: boolean
  withdrawnAt?: string | null
  todoKey: string
  preview: string
  selector: string
  pageUrl: string
  at: number
  reviewerStatus?: ReviewerStatus
  outcomeReason?: string | null
}

export type MinePage = {
  items: SentFeedback[]
  nextCursor: string | null
  counts: { open: number; discarded: number; done: number }
}

export type MineStatusFilter = 'open' | 'discarded' | 'done' | 'all'

const STATUS_LABEL: Record<ReviewerStatus, string> = {
  open: 'Offen',
  done: 'Erledigt',
  discarded: 'Verworfen',
}

export type ChromeApi = {
  root: HTMLElement
  setMarking: (on: boolean) => void
  isMarking: () => boolean
  addSent: (item: SentFeedback) => void
  seedSent: (items: SentFeedback[]) => void
  getSent: () => SentFeedback[]
  showEnded: () => void
  destroy: () => void
}

export function mountChrome(input: {
  actorLabel?: string | null
  onToggleMark: () => void
  onOpenList: () => void
  onRequestEnd: () => void
  onConfirmEnd: () => void
  onMarkingChange?: (on: boolean) => void
  onSentChange?: (items: SentFeedback[]) => void
  onFocusSent?: (item: SentFeedback) => void
  onWithdraw?: (item: SentFeedback) => Promise<{ withdrawnAt: string }>
  onLoadMine?: (opts: {
    status: MineStatusFilter
    cursor?: string | null
  }) => Promise<MinePage>
}): ChromeApi {
  const root = document.createElement('div')
  root.setAttribute('data-klfb-root', '1')
  const shadow = root.attachShadow({ mode: 'open' })
  const withdrawal = input.onWithdraw ? mountWithdrawalControls(shadow, {
    onWithdraw: input.onWithdraw,
    onSuccess: (item, withdrawnAt) => {
      const cached = sent.find(s => s.todoKey === item.todoKey)
      if (cached) Object.assign(cached, { withdrawnAt, reviewerStatus: 'discarded', canWithdraw: false })
      const current = listItems.find(s => s.todoKey === item.todoKey)
      if (current) Object.assign(current, { withdrawnAt, reviewerStatus: 'discarded', canWithdraw: false })
      if (filterStatus === 'open') listItems = listItems.filter(s => s.todoKey !== item.todoKey)
      counts.open = Math.max(0, counts.open - 1); counts.discarded += 1
      renderList(); notifyPins()
      void refreshMine(false).catch(() => undefined)
      requestAnimationFrame(() => (shadow.querySelector('[data-list-close]') as HTMLButtonElement | null)?.focus())
    },
  }) : null
  const style = document.createElement('style')
  style.textContent = CHROME_CSS
  shadow.appendChild(style)

  const layer = document.createElement('div')
  layer.className = 'layer'
  layer.innerHTML = `
    <div class="toast" data-toast>
      <strong data-toast-title>Markier-Modus</strong>
      <span data-toast-sub>Tippe auf ein Element — Links werden nicht geöffnet.</span>
    </div>
    <div class="onboard" data-onboard aria-live="polite">
      <div class="step-dots" data-dots><i class="active"></i><i></i><i></i><i></i></div>
      <div class="viz" aria-hidden="true">
        <div class="viz-scene active" data-viz="0">
          <div class="viz-page"><div class="viz-line w80"></div><div class="viz-line w60"></div><div class="viz-line w40"></div></div>
          <div class="viz-fab">FB</div>
          <div class="viz-ptr">${PTR_SVG}</div>
        </div>
        <div class="viz-scene" data-viz="1">
          <div class="viz-page"><div class="viz-line w80"></div><div class="viz-line w60"></div><div class="viz-block"></div></div>
          <div class="viz-fab">FB</div>
          <div class="viz-ptr">${PTR_SVG}</div>
        </div>
        <div class="viz-scene" data-viz="2">
          <div class="viz-page" style="bottom:52px"><div class="viz-line w60"></div><div class="viz-block" style="outline:2px solid #6D28D9"></div></div>
          <div class="viz-composer">
            <span class="grow"><span class="ph">Nachricht…</span><span class="typed">Headline kürzer</span></span>
            <span class="viz-action"><span class="viz-mic">🎙</span><span class="viz-send">➤</span></span>
          </div>
        </div>
        <div class="viz-scene" data-viz="3">
          <div class="viz-page"><div class="viz-line w80"></div><div class="viz-line w40"></div></div>
          <div class="viz-menu-chip">Fertig · abschließen</div>
          <div class="viz-menu-chip">Meine Feedbacks</div>
          <div class="viz-fab">FB</div>
          <div class="viz-ptr">${PTR_SVG}</div>
        </div>
      </div>
      <strong data-onboard-title>Button tippen</strong>
      <p data-onboard-body>Startet den Markier-Modus.</p>
      <div class="onboard-row">
        <button type="button" class="skip" data-onboard-skip>Überspringen</button>
        <button type="button" class="next" data-onboard-next>Weiter</button>
      </div>
    </div>
    <div class="confirm" data-confirm role="dialog" aria-label="Feedback abschließen">
      <div class="emoji" aria-hidden="true">✓</div>
      <h4>Feedback abschließen?</h4>
      <p>Alles Gesendete bleibt in Kiwiloop. Du kannst die Seite danach ganz normal weiter nutzen.</p>
      <div class="confirm-row">
        <button type="button" class="cancel" data-end-cancel>Noch weitermachen</button>
        <button type="button" class="primary" data-end-confirm>Ja, fertig</button>
      </div>
    </div>
    <div class="ended" data-ended>
      <strong>Danke für dein Feedback</strong>
      <span>Der Feedback-Modus ist beendet. Für eine neue Runde brauchst du einen neuen Magic Link.</span>
    </div>
    <div class="list-backdrop" data-list-backdrop></div>
    <div class="list-sheet" data-list role="dialog" aria-label="Meine Feedbacks">
      <button type="button" class="sheet-drag" data-sheet-drag aria-label="Sheet-Höhe anpassen">
        <span class="sheet-drag-bar" aria-hidden="true"></span>
      </button>
      <div class="sheet-head">
        <h3>Meine Feedbacks</h3>
        <button type="button" class="sheet-filter" data-filter-toggle aria-expanded="false" aria-controls="klfb-filter-panel">
          Filter
        </button>
        <button type="button" class="sheet-close" data-list-close aria-label="Schließen">×</button>
      </div>
      <div id="klfb-filter-panel" class="filter-panel" data-filter-panel hidden role="group" aria-label="Statusfilter">
        <div class="filters" data-filters>
          <button type="button" class="on" data-filter="open">Offen</button>
          <button type="button" data-filter="discarded">Verworfen</button>
          <button type="button" data-filter="done">Erledigt</button>
          <button type="button" data-filter="all">Alle</button>
        </div>
      </div>
      <p class="hint" data-list-hint>Nur Feedbacks aus dem aktuellen Magic-Link.</p>
      <div class="list-scroll">
        <div data-list-body class="list-empty">Noch nichts gesendet.</div>
        <button type="button" class="load-more" data-load-more hidden>Weitere laden</button>
      </div>
    </div>
    <div class="fab-stack">
      <div class="fab-menu" data-fab-menu>
        <button type="button" class="fab-chip" data-list-open>Meine Feedbacks</button>
        <button type="button" class="fab-chip done" data-end>Fertig · abschließen</button>
      </div>
      <button type="button" class="fab-main" data-fab title="Feedback — halten für Menü">
        <span data-fab-label>FB</span>
      </button>
    </div>
  `
  shadow.appendChild(layer)
  document.body.appendChild(root)

  const fab = shadow.querySelector('[data-fab]') as HTMLButtonElement
  const fabLabel = shadow.querySelector('[data-fab-label]') as HTMLElement
  const fabMenu = shadow.querySelector('[data-fab-menu]') as HTMLElement
  const toast = shadow.querySelector('[data-toast]') as HTMLElement
  const toastTitle = shadow.querySelector('[data-toast-title]') as HTMLElement
  const toastSub = shadow.querySelector('[data-toast-sub]') as HTMLElement
  const onboard = shadow.querySelector('[data-onboard]') as HTMLElement
  const onboardTitle = shadow.querySelector('[data-onboard-title]') as HTMLElement
  const onboardBody = shadow.querySelector('[data-onboard-body]') as HTMLElement
  const onboardDots = shadow.querySelector('[data-dots]') as HTMLElement
  const confirm = shadow.querySelector('[data-confirm]') as HTMLElement
  const ended = shadow.querySelector('[data-ended]') as HTMLElement
  const listSheet = shadow.querySelector('[data-list]') as HTMLElement
  const listBackdrop = shadow.querySelector('[data-list-backdrop]') as HTMLElement
  const listBody = shadow.querySelector('[data-list-body]') as HTMLElement
  const listHint = shadow.querySelector('[data-list-hint]') as HTMLElement
  const filterToggle = shadow.querySelector('[data-filter-toggle]') as HTMLButtonElement
  const filterPanel = shadow.querySelector('[data-filter-panel]') as HTMLElement
  const loadMoreBtn = shadow.querySelector('[data-load-more]') as HTMLButtonElement
  const sheetDrag = shadow.querySelector('[data-sheet-drag]') as HTMLButtonElement

  let marking = false
  let menuOpen = false
  let longPressTimer: number | null = null
  let longPressFired = false
  let onboardStep = 0
  let toastTimer: number | null = null
  const sent: SentFeedback[] = []
  let filterStatus: MineStatusFilter = 'open'
  let listItems: SentFeedback[] = []
  let nextCursor: string | null = null
  let counts = { open: 0, discarded: 0, done: 0 }
  let loadingList = false

  const actorName = (input.actorLabel?.trim() || 'Du')
  const actorInitials = actorName
    .split(/\s+/)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .slice(0, 2)
    .join('') || '?'

  const isDesktop = () => window.matchMedia('(min-width: 768px)').matches

  const showToast = (title: string, sub: string, ms = 2600) => {
    toastTitle.textContent = title
    toastSub.textContent = sub
    toast.classList.add('show')
    if (toastTimer != null) window.clearTimeout(toastTimer)
    toastTimer = window.setTimeout(() => toast.classList.remove('show'), ms)
  }

  const setMarking = (on: boolean) => {
    marking = on
    fab.classList.toggle('marking', on)
    fabLabel.textContent = on ? '×' : 'FB'
    input.onMarkingChange?.(on)
    if (on) {
      showToast(
        'Markier-Modus',
        isDesktop()
          ? 'Klicke auf ein Element — normale Links sind pausiert.'
          : 'Tippe auf ein Element — Links werden nicht geöffnet.',
      )
    } else {
      toast.classList.remove('show')
    }
  }

  const syncFilterChips = () => {
    filterPanel.querySelectorAll<HTMLButtonElement>('[data-filter]').forEach((btn) => {
      const id = btn.getAttribute('data-filter') as MineStatusFilter
      btn.classList.toggle('on', id === filterStatus)
      const n =
        id === 'all'
          ? counts.open + counts.discarded + counts.done
          : counts[id as 'open' | 'discarded' | 'done']
      const label =
        id === 'open' ? 'Offen' : id === 'discarded' ? 'Verworfen' : id === 'done' ? 'Erledigt' : 'Alle'
      btn.textContent = `${label} ${n}`
    })
    let dot = filterToggle.querySelector('.dot')
    if (filterStatus !== 'open') {
      if (!dot) {
        dot = document.createElement('span')
        dot.className = 'dot'
        dot.setAttribute('aria-hidden', 'true')
        filterToggle.prepend(dot)
      }
    } else if (dot) {
      dot.remove()
    }
  }

  const syncListHint = () => {
    const n =
      filterStatus === 'all'
        ? counts.open + counts.discarded + counts.done
        : counts[filterStatus]
    if (filterStatus === 'open') {
      listHint.textContent =
        n <= 0
          ? 'Keine offenen Feedbacks in diesem Magic-Link.'
          : n === 1
            ? '1 offenes Feedback. Tippen öffnet die Stelle.'
            : `${n} offene Feedbacks. Tippen öffnet die Stelle.`
      return
    }
    if (filterStatus === 'discarded') {
      listHint.textContent = 'Verworfene Feedbacks · Tippen öffnet die Stelle.'
      return
    }
    if (filterStatus === 'done') {
      listHint.textContent = 'Erledigte Feedbacks · Tippen öffnet die Stelle.'
      return
    }
    listHint.textContent = 'Alle Status · Tippen öffnet die Stelle.'
  }

  const escapeHtml = (s: string) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

  const relativeLabel = (at: number) => {
    const sec = Math.max(0, Math.round((Date.now() - at) / 1000))
    if (sec < 60) return 'gerade eben'
    const min = Math.round(sec / 60)
    if (min < 60) return `vor ${min} Min`
    const h = Math.round(min / 60)
    return `vor ${h} Std`
  }

  const pagePathLabel = (url: string) => {
    try {
      const u = new URL(url)
      return u.pathname || '/'
    } catch {
      return url
    }
  }

  const notifyPins = () => {
    const forPins =
      filterStatus === 'open'
        ? listItems.filter((s) => (s.reviewerStatus ?? 'open') === 'open')
        : listItems
    input.onSentChange?.(forPins)
  }

  const renderList = () => {
    syncFilterChips()
    syncListHint()
    loadMoreBtn.hidden = !nextCursor
    if (!listItems.length) {
      withdrawal?.render([])
      listBody.className = 'list-empty'
      listBody.textContent =
        filterStatus === 'open'
          ? 'Keine offenen Feedbacks.'
          : filterStatus === 'discarded'
            ? 'Keine verworfenen Feedbacks.'
            : filterStatus === 'done'
              ? 'Keine erledigten Feedbacks.'
              : 'Noch nichts gesendet.'
      return
    }
    listBody.className = ''
    const ordered = listItems.slice().reverse()
    listBody.innerHTML = ordered
      .map((s, i) => {
        const idx = listItems.length - i
        const st = s.reviewerStatus ?? 'open'
        const preview = escapeHtml(s.preview)
        const path = escapeHtml(pagePathLabel(s.pageUrl || location.href))
        const reason =
          st === 'discarded' && !s.withdrawnAt
            ? `<div class="feed-reason"><strong>Begründung</strong>${escapeHtml(s.outcomeReason?.trim() || 'Keine Begründung hinterlegt')}</div>`
            : ''
        return `
      <div class="feedback-row"><button type="button" class="feed-item" data-todo-key="${escapeHtml(s.todoKey)}">
        <div class="feed-head">
          <span class="feed-idx">${idx}</span>
          <div class="feed-who" style="flex:1">
            <div class="sub"><span>${relativeLabel(s.at)}</span></div>
          </div>
          <span class="feed-status ${st}">${s.withdrawnAt ? (s.ownFeedback ? 'Von dir zurückgenommen' : 'Vom Feedbackgeber zurückgenommen') : STATUS_LABEL[st]}</span>
        </div>
        <p class="feed-body">${preview}</p>
        <div class="feed-quote"><div class="q-meta">${path}</div></div>
        ${reason}
      </button><div class="feedback-actions" data-withdraw-host="${escapeHtml(s.todoKey)}"></div></div>`
      })
      .join('')
    withdrawal?.render(ordered.filter(s => s.canWithdraw && (s.reviewerStatus ?? 'open') === 'open' && !s.withdrawnAt).map(item => ({
      item, host: Array.from(listBody.querySelectorAll<HTMLElement>('[data-withdraw-host]')).find(el => el.dataset.withdrawHost === item.todoKey)!,
    })))

    listBody.querySelectorAll<HTMLButtonElement>('.feed-item').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-todo-key')
        const item = listItems.find((s) => s.todoKey === key)
        if (!item) return
        closeList()
        input.onFocusSent?.(item)
      })
    })
  }

  const applyMinePage = (page: MinePage, append: boolean) => {
    counts = page.counts
    nextCursor = page.nextCursor
    if (append) {
      const seen = new Set(listItems.map((i) => i.todoKey))
      for (const it of page.items) {
        if (!seen.has(it.todoKey)) listItems.push(it)
      }
    } else {
      listItems = page.items.slice()
    }
    renderList()
    notifyPins()
  }

  const refreshMine = async (append = false) => {
    if (!input.onLoadMine) {
      // Offline fallback: local cache filtered
      counts = { open: 0, discarded: 0, done: 0 }
      for (const s of sent) {
        const st = s.reviewerStatus ?? 'open'
        counts[st] += 1
      }
      listItems =
        filterStatus === 'all'
          ? sent.slice()
          : sent.filter((s) => (s.reviewerStatus ?? 'open') === filterStatus)
      nextCursor = null
      renderList()
      notifyPins()
      return
    }
    if (loadingList) return
    loadingList = true
    try {
      const page = await input.onLoadMine({
        status: filterStatus,
        cursor: append ? nextCursor : null,
      })
      applyMinePage(page, append)
    } finally {
      loadingList = false
    }
  }

  const openList = () => {
    listSheet.classList.add('show')
    listBackdrop.classList.add('show')
    fabMenu.classList.remove('open')
    menuOpen = false
    input.onOpenList()
    void refreshMine(false)
  }

  const closeList = () => {
    listSheet.classList.remove('show')
    listBackdrop.classList.remove('show')
    filterPanel.classList.remove('show')
    filterPanel.hidden = true
    filterToggle.setAttribute('aria-expanded', 'false')
  }

  const onboardDone = () => {
    try {
      return localStorage.getItem(ONBOARD_KEY) === '1'
    } catch {
      return false
    }
  }

  const finishOnboard = () => {
    try {
      localStorage.setItem(ONBOARD_KEY, '1')
    } catch {
      /* ignore */
    }
    onboard.classList.remove('show')
  }

  const renderOnboard = () => {
    const step = ONBOARD_STEPS[onboardStep]
    if (!step) {
      finishOnboard()
      return
    }
    onboardTitle.textContent = step.title
    onboardBody.textContent = step.body
    ;[...onboardDots.children].forEach((dot, i) => {
      ;(dot as HTMLElement).classList.toggle('active', i === onboardStep)
    })
    shadow.querySelectorAll('.viz-scene').forEach((scene) => {
      scene.classList.toggle('active', scene.getAttribute('data-viz') === String(onboardStep))
    })
    ;(shadow.querySelector('[data-onboard-next]') as HTMLButtonElement).textContent =
      onboardStep >= ONBOARD_STEPS.length - 1 ? 'Los geht’s' : 'Weiter'
  }

  const showOnboard = () => {
    if (onboardDone()) return
    onboardStep = 0
    renderOnboard()
    onboard.classList.add('show')
  }

  shadow.querySelector('[data-onboard-skip]')!.addEventListener('click', (e) => {
    e.stopPropagation()
    finishOnboard()
  })
  shadow.querySelector('[data-onboard-next]')!.addEventListener('click', (e) => {
    e.stopPropagation()
    if (onboardStep >= ONBOARD_STEPS.length - 1) finishOnboard()
    else {
      onboardStep += 1
      renderOnboard()
    }
  })

  const closeMenu = () => {
    fabMenu.classList.remove('open')
    menuOpen = false
  }

  fab.addEventListener('pointerdown', (e) => {
    if (e.button !== 0 && e.pointerType === 'mouse') return
    longPressFired = false
    longPressTimer = window.setTimeout(() => {
      longPressFired = true
      menuOpen = true
      fabMenu.classList.add('open')
      setMarking(false)
    }, 480)
  })
  const clearLongPress = () => {
    if (longPressTimer != null) {
      window.clearTimeout(longPressTimer)
      longPressTimer = null
    }
  }
  fab.addEventListener('pointerup', clearLongPress)
  fab.addEventListener('pointercancel', clearLongPress)
  fab.addEventListener('pointerleave', clearLongPress)

  fab.addEventListener('click', (e) => {
    e.stopPropagation()
    if (longPressFired) {
      longPressFired = false
      return
    }
    if (menuOpen) {
      closeMenu()
      return
    }
    if (onboard.classList.contains('show')) finishOnboard()
    input.onToggleMark()
  })

  shadow.querySelector('[data-list-open]')!.addEventListener('click', (e) => {
    e.stopPropagation()
    closeMenu()
    openList()
  })
  shadow.querySelector('[data-list-close]')!.addEventListener('click', closeList)
  listBackdrop.addEventListener('click', closeList)

  filterToggle.addEventListener('click', (e) => {
    e.stopPropagation()
    const open = filterToggle.getAttribute('aria-expanded') === 'true'
    filterToggle.setAttribute('aria-expanded', open ? 'false' : 'true')
    filterPanel.classList.toggle('show', !open)
    filterPanel.hidden = open
  })
  filterPanel.querySelectorAll<HTMLButtonElement>('[data-filter]').forEach((chip) => {
    chip.addEventListener('click', () => {
      const next = chip.getAttribute('data-filter') as MineStatusFilter
      if (!next || next === filterStatus) return
      filterStatus = next
      void refreshMine(false)
    })
  })
  loadMoreBtn.addEventListener('click', () => {
    if (nextCursor) void refreshMine(true)
  })

  {
    let dragging = false
    const MIN = 36
    const MAX = 90
    const setH = (clientY: number) => {
      const vh = window.innerHeight || 1
      const fromBottom = vh - clientY
      let pct = (fromBottom / vh) * 100
      pct = Math.max(MIN, Math.min(MAX, pct))
      listSheet.style.setProperty('--sheet-h', `${pct.toFixed(1)}%`)
    }
    sheetDrag.addEventListener('pointerdown', (e) => {
      dragging = true
      sheetDrag.setPointerCapture(e.pointerId)
      e.preventDefault()
    })
    sheetDrag.addEventListener('pointermove', (e) => {
      if (dragging) setH(e.clientY)
    })
    sheetDrag.addEventListener('pointerup', () => {
      dragging = false
    })
    sheetDrag.addEventListener('pointercancel', () => {
      dragging = false
    })
  }

  shadow.querySelector('[data-end]')!.addEventListener('click', (e) => {
    e.stopPropagation()
    closeMenu()
    confirm.classList.add('show')
    input.onRequestEnd()
  })
  shadow.querySelector('[data-end-cancel]')!.addEventListener('click', () => {
    confirm.classList.remove('show')
  })
  shadow.querySelector('[data-end-confirm]')!.addEventListener('click', () => {
    confirm.classList.remove('show')
    input.onConfirmEnd()
  })

  const onDocPointer = (e: PointerEvent) => {
    if (!menuOpen) return
    const path = e.composedPath()
    if (path.includes(fab) || path.includes(fabMenu)) return
    closeMenu()
  }
  document.addEventListener('pointerdown', onDocPointer, true)

  if (input.actorLabel) {
    /* reserved for future meta */
  }

  showOnboard()
  syncListHint()

  return {
    root,
    setMarking,
    isMarking: () => marking,
    addSent: (item) => {
      const normalized: SentFeedback = {
        ...item,
        reviewerStatus: item.reviewerStatus ?? 'open',
        pageUrl: item.pageUrl || location.href.split('#')[0]!,
      }
      sent.push(normalized)
      counts.open += 1
      if (filterStatus === 'open' || filterStatus === 'all') {
        listItems.push(normalized)
      }
      syncListHint()
      syncFilterChips()
      if (listSheet.classList.contains('show')) renderList()
      notifyPins()
    },
    seedSent: (items) => {
      sent.length = 0
      for (const item of items) {
        sent.push({
          ...item,
          reviewerStatus: item.reviewerStatus ?? 'open',
          pageUrl: item.pageUrl || location.href.split('#')[0]!,
        })
      }
      // Initial pins: open only until list refresh
      listItems = sent.filter((s) => (s.reviewerStatus ?? 'open') === 'open')
      counts = { open: 0, discarded: 0, done: 0 }
      for (const s of sent) counts[s.reviewerStatus ?? 'open'] += 1
      notifyPins()
      if (listSheet.classList.contains('show')) void refreshMine(false)
    },
    getSent: () => sent.slice(),
    showEnded: () => {
      closeMenu()
      closeList()
      confirm.classList.remove('show')
      onboard.classList.remove('show')
      toast.classList.remove('show')
      fab.classList.add('hidden')
      fabMenu.classList.add('hidden')
      ended.classList.add('show')
    },
    destroy: () => {
      withdrawal?.destroy()
      document.removeEventListener('pointerdown', onDocPointer, true)
      clearLongPress()
      root.remove()
    },
  }
}
